import React from "react";
import { Offcanvas } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import "./sidedrawer.css";

const SideDrawer = ({ show, handleClose, className,children }) => {
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        className={`sustom_drawer ${className}`}
        placement={"end"}
      >
        <Offcanvas.Body>
          <button className="close_button" onClick={handleClose}>
            <FaTimes />
          </button>
            {children}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SideDrawer;
